import { useEffect, useState } from 'react';

// Service
import CashRegisterService from '../../services/cashRegisterService';

//Hooks
import useUser from '../user/useUser';

// Models
import { cashTypesFormat } from '../../models/CashRegisterMovementEntity';
import { utils } from '../../utils/utils';

const usePaymentMethodSummary = () => {
    const { branch, cashRegister } = useUser();
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState({
        from: utils.getDateNow(),
        to: utils.getDateNow(),
        cashRegisterId: cashRegister?.id,
        branchId: branch.id,
        isImprest: false
    });

    const [paymentMethodSummary, setPaymentMethodSummary] = useState([]);

    const mapPaymentMethodSummaryItems = (res) => {
        if(res.length <= 0)
            return [];

        const result = res.map(item => ({
            ...item,
            cashTypeTranslated: item.cashType === 'Cash' 
                ? cashTypesFormat[item.cashType + item.currency] 
                : cashTypesFormat[item.cashType],
            cantTickets: item.cantTickets !== 0 
                ? item.cantTickets 
                : null
        }))

        const byCurrency = utils.groupBy(result, 'currency');

        const subTotals = Object
            .keys(byCurrency)
            .map(currency => ({
                cashTypeTranslated: `Total - ${currency}:`,
                price: byCurrency[currency][0].price,
                lastClosureAmount: byCurrency[currency].reduce((a, b) => a + b.lastClosureAmount, 0),
                ingressTotal: byCurrency[currency].reduce((a, b) => a + b.ingressTotal, 0),
                egressTotal: byCurrency[currency].reduce((a, b) => a + b.egressTotal, 0),
                total: byCurrency[currency].reduce((a, b) => a + b.total, 0),
                cantTickets: byCurrency[currency].reduce((a, b) => a + b.cantTickets, 0),
            }));

        const total = ({
            cashTypeTranslated: `Total:`,
            lastClosureAmount: subTotals.reduce((a, b) => a + b.lastClosureAmount * b.price, 0),
            ingressTotal: subTotals.reduce((a, b) => a + b.ingressTotal * b.price, 0),
            egressTotal: subTotals.reduce((a, b) => a + b.egressTotal * b.price, 0),
            total: subTotals.reduce((a, b) => a + b.total * b.price, 0),
            cantTickets: subTotals.reduce((a, b) => a + b.cantTickets, 0),
        })

        return [...result, ...subTotals, total];
    }

    useEffect(() => {
        setFilters(state => ({ ...state, cashRegisterId: cashRegister?.id, branchId: branch.id }))
    }, [branch, cashRegister])

    useEffect(() => {
        const getPaymentMethodSummary = () => {
            setLoading(true);
            return CashRegisterService
                .GetPaymentMethodSummary(filters)
                .then(res => setPaymentMethodSummary(mapPaymentMethodSummaryItems(res)))
                .finally(() => setLoading(false))
        }

        if (!loading && filters.branchId > 0)
            getPaymentMethodSummary();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])

    return {
        paymentMethodSummary,
        filters,
        loading,
        setFilters,
    };
}

export default usePaymentMethodSummary;